import { FACILITY_AND_SPACE_FEATURES, LocationVarKey } from "@swivl-mono/types";

import { SearchableLabel } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { TOPIC_VARS_BY_ID } from "../../../Views/Properties/CortexV3/Topics";
import { CortexTopicWorksheet } from "../Components/CortexTopicWorksheet";

export const PAGE_KEYS: LocationVarKey[] = TOPIC_VARS_BY_ID["amenities-and-services"] ?? [];

export const SEARCH_LABELS: SearchableLabel[] = FACILITY_AND_SPACE_FEATURES.map((f) => ({ title: f.label, snippet: f.description }));

export default function AmenitiesPage(): React.ReactElement {
  return (
    <CortexTopicWorksheet
      topicId="amenities-and-services"
      heading="Amenities & Services"
      description="Check the amenities, services, and storage types your facility offers."
      sectionEditing
    />
  );
}
